module.exports = __webpack_public_path__ + "img/logo_login.45e3adef.png";